export const AI_SUGGESTION_CONTENT_STYLE = [
  `span.mce-suggestion-pending { background-color: #ede9fc; border-radius: 2px; padding: 1px 2px; }`,
  `span.mce-suggestion-original { background-color: #fdeeee; color: #a4373a; text-decoration: line-through; padding: 1px 2px; border-radius: 2px; opacity: 1; }`,
  `span.mce-suggestion-original::after { content: ' \\2192 '; color: #5a6872; text-decoration: none; }`,
  `span.mce-suggestion-proposal { background-color: #eaf6ec; border-bottom: 2px solid #2e7d32; border-radius: 2px; padding: 1px 2px; }`,
].join(' ');

export const AI_MIN_SELECTION_WORDS = 10;

export const AI_HINT_DISMISSED_KEY = 'ai-contextual-hint-dismissed';

export const AI_HINT_EXPIRY_HOURS = 24 * 30;
